import React from 'react';
import { Icon } from '@iconify/react';
import { HighlightedTextIcon } from 'components/molecules';
import { AboutSectionContentProps } from 'components/organisms/About/types';
import reactIcon from '@iconify/icons-logos/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';

const Text = () => (
    <>
        Je conçois des solutions web full-stack de pointe avec <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactIcon} />}
        >
            <span className="font-bold text-gray-800">React</span>
        </HighlightedTextIcon>
        {', '} <HighlightedTextIcon as="a" href="https://www.typescriptlang.org/" className="mx-2" icon={<img src="/img/typescript.svg" alt="TypeScript" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">TypeScript</span>
        </HighlightedTextIcon>, et <HighlightedTextIcon as="a" href="https://supabase.com/" className="mx-2" icon={<img src="/img/supabase.svg" alt="Supabase" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Supabase</span>
        </HighlightedTextIcon>. Ma spécialité est le développement d'interfaces utilisateur réactives et de backends solides pour des applications web modernes. J'aime construire des applications web prêtes pour la production en utilisant
        <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactIcon} />}
        >
            <span className="font-bold text-gray-800">React</span>
        </HighlightedTextIcon>
        {' '}et
        <HighlightedTextIcon
            as="a"
            href="https://tailwindcss.com"
            className="mx-2"
            icon={<Icon icon={tailwindcssIcon} />}
        >
            <span className="font-bold text-gray-800">TailwindCSS</span>
        </HighlightedTextIcon>
        {' '}et
        <HighlightedTextIcon
            as="a"
            href="https://ui.shadcn.com/"
            className="mx-2"
            icon={<img src="/img/shadcn.svg" alt="ShadCN" className="w-5 h-5" />}
        >
            <span className="font-bold text-gray-800">ShadCN/UI</span>
        </HighlightedTextIcon>

        {'. '}J'ai aussi de l'expérience dans la création d'applications web avec
        <HighlightedTextIcon as="a" href="https://nextjs.org/" className="mx-2" icon={<img src="/img/nextjs.svg" alt="Next.js" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Next.js</span>
        </HighlightedTextIcon>. Je travaille avec ces outils depuis environ <span className="font-bold text-gray-800">2 ans</span> maintenant et je suis confiant dans la création d'applications avec eux. J'ai effectué un stage en tant que développeur web chez

        <HighlightedTextIcon as="a" href="https://weabers.com/" className="mx-2" icon={<img src="/img/weabers.avif" alt="Weabers" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">Weabers</span>
        </HighlightedTextIcon>{'. '} Je suis aussi un <HighlightedTextIcon as='a' href="https://www.sports.com" className="mx-2" icon={<img src="/img/sports.svg" alt="sports" className="w-5 h-5" />}>
            <span className="font-bold text-gray-800">passionné de sport</span>
        </HighlightedTextIcon> et un <HighlightedTextIcon
            as='a'
            href="https://robocopplays.netlify.app/"
            className="mx-2"
            icon={<img src="/img/gamer.svg" alt="gamer" className="w-5 h-5" />}
        >
            <span className="font-bold text-gray-800">joueur</span>
        </HighlightedTextIcon>.
    </>
);

const about: AboutSectionContentProps = {
    text: <Text />,
};

export default about;
